module.exports = __webpack_public_path__ + "media/bundles/ReactHome/components/kind-ad18c5e143f007550c13f8628f87b401.png";